var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.htmlTag,{tag:"component",class:[_vm.name, _vm.getClassName],domProps:{"innerHTML":_vm._s(_vm.cms.heading)}})
}
var staticRenderFns = []

export { render, staticRenderFns }